import "react-toastify/dist/ReactToastify.css";
import { useRoutes } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import ShowCase from "../pages/ShowCase";
import NotFoundPage from "../pages/NotFoundPage";
import Project from "../pages/Project";
import Trending from "../pages/Trending";
import Moodboard from "../pages/moodBoard/Moodboard";
import Error500 from "../pages/Error500";
import Wizard from "../pages/moodBoard/Wizard";
import ChoosePlan from "../pages/moodBoard/ChoosePlan";
import ImagePreview from "../pages/ImagePreview";
import TrendingCategorey from "../pages/TrendingCategorey";
import ImageMapper from "../pages/moodBoard/ImageMapper";
import SelfMoodBoard from "../pages/moodBoard/SelfMoodBoard";
import EditImageMapper from "../pages/moodBoard/EditImageMapper";
import AddUser from "../pages/admin/AddUser";
import UserList from "../pages/admin/UserList";
import EditUser from "../pages/admin/EditUser";
import ProjectShowcase from "../pages/project-showcase/ProjectShowcase";
import ProjectListing from "../pages/project-showcase/ProjectListing";
import ProjectShowcaseAdd from "../pages/project-showcase/admin/ProjectShowcaseAdd";
import ProjectShowcaseView from "../pages/project-showcase/admin/ProjectShowcaseView";
import ProjectShowcaseList from "../pages/project-showcase/admin/ProjectShowcaseList";
import AuthWrapper from "./AuthWrapper";
import ImageUploadAdd from "../pages/project-showcase/admin/ImageUploadAdd";
import ImageUploadEdit from "../pages/project-showcase/admin/ImageUploadEdit";
import Intro from "../components/Intro";
import Material from "../pages/material/Material";
// import MaterialIntroPage from "../pages/material/IntroPage";
import IntroPage from "../pages/material/IntroPage";
import MaterialFilter from "../pages/material/material-filter/MaterialFilter";
import ProjectWrapper from "../pages/project-showcase/ProjectWrapper";
import MaterialDesign from "../pages/project-showcase/materialDesign";
import DesignMain from "../pages/project-showcase/design";
import Presentation from "../pages/project-showcase/admin/Presentation/Presentation";
import Layout from "../pages/Layout";
import ProjectData from "../pages/project-showcase/ProjectData";
import AddMaterial from "../pages/material/material-filter/AddMaterial";
import AllProjects from "../pages/project-showcase/admin/AllProjects";
import PublicView from "../pages/project-showcase/materialDesign/PublicView";
import SuperAdminAccess from "./SuperAdminAccess";
import Unauthorized from "../components/Unauthorized";
import MainPublicView from "../pages/project-showcase/materialDesign/MainPublicView";
import PublicViewRender from "../pages/project-showcase/admin/Presentation/PublicViewRender";
import BasicInfo from "../pages/project-showcase/basicInfo/BasicInfo";
import Collections from "../pages/collections/Collections";
import Profile from "../pages/profile/Profile";

export default function AppRoutes() {
  let element = useRoutes([
    // public paths starts here
    { path: "/error500", element: <Error500 /> },
    { path: "*", element: <NotFoundPage /> },
    { path: "/", element: <Login /> },
    { path: "/project-detail/:id", element: <ProjectShowcase /> },
    { path: "/unauthorized", element: <Unauthorized /> },
    { path: "/public-view/:projectName/:id", element: <PublicView /> },
    // { path: "/edit-public-view/:projectName/:id", element: <PublicView /> },

    {
      path: "/pv/:type/:id/:projectName",
      element: <PublicViewRender />,
    },

    // protected paths starts here
    {
      path: "/",
      element: <AuthWrapper />, // Wrap all protected routes with AuthWrapper
      children: [
        {
          path: "project-showcase",
          // element: <Layout/>,
          children: [
            { index: true, element: <ProjectListing /> },
            { path: "add", element: <ImageUploadAdd /> },
            { path: "all", element: <AllProjects /> },
            {
              path: ":id",
              element: <ProjectData />,
              children: [
                { index: true, element: <ProjectShowcaseView /> },
                {
                  path: "edit",
                  element: <ProjectWrapper />, // contains outlet context
                  children: [
                    {
                      path: "basic-info",
                      element: <BasicInfo />,
                    },
                    {
                      path: "projects",
                      children: [
                        { index: true, element: <ProjectShowcaseAdd /> },

                        { path: "re-upload", element: <ImageUploadEdit /> },
                      ],
                    },
                    {
                      path: "material",
                      // element: <MaterialDesign />,
                      children: [
                        { index: true, element: <MaterialDesign /> },
                        { path: "public-view", element: <PublicView /> },
                      ],
                    },
                    {
                      path: "design",
                      children: [{ index: true, element: <DesignMain /> }],
                    },
                    {
                      path: "presentation",
                      children: [{ index: "true", element: <Presentation /> }],
                    },
                  ],
                },
              ],
            },
          ],
          // element: <ProjectWrapper />,
          // children: [
          //   {
          //     path: "projects",
          //     children: [
          //       { index: true, element: <ProjectShowcaseList /> }, // done
          //       { path: "add", element: <ImageUploadAdd /> },  // done
          //       { path: ":id/re-upload", element: <ImageUploadEdit /> }, //done
          //       { path: ":id/add", element: <ProjectShowcaseAdd /> }, //done
          //       { path: "view/:id", element: <ProjectShowcaseView /> }, //done
          //     ],
          //   },

          //   {
          //     path: "material",
          //     // element: <MaterialDesign />,
          //     children: [{ index: true, element: <MaterialDesign /> }],
          //   },
          //   {
          //     path: "design",
          //     children: [
          //       {index: true, element: <DesignMain/>}
          //     ]
          //   },
          //   {
          //     path: "presentation",
          //     children: [
          //       {index: "true", element : <Presentation/>
          //       }
          //     ]
          //   }
          // ],
        },
        {
          path: "moodboard",
          children: [
            { index: true, element: <Wizard /> },
            { path: "image-mapper", element: <ImageMapper /> },
            { path: "image-mapper/:floorId", element: <EditImageMapper /> },
            { path: "plan", element: <ChoosePlan /> },
            { path: "floorId/:floorId", element: <Moodboard /> },
          ],
        },
        {
          path: "material",
          element: <Material />,
          children: [
            {
              path: "",
              index: true,
              element: <IntroPage />,
            },
            {
              path: "material-filter",
              element: <MaterialFilter />,
            },
            {
              path: "delete-materials",
              element: <MaterialFilter isDelete={true} />,
            },
            {
              path: "material-filter/add",
              element: <AddMaterial />,
            },
          ],
        },
        // {
        //   path: "/material-filter",
        //   element: <MaterialFilter/>
        // },
        { path: "showcase", element: <ShowCase /> },
        { path: "project", element: <Project /> },
        { path: "collections", element: <Collections /> },
        { path: "presentation", element: <Presentation isRandom={true} /> },

        { path: "trending", element: <Trending /> },
        { path: "trending/:category", element: <TrendingCategorey /> },
        { path: "self-moodboard/floorId/:floorId", element: <SelfMoodBoard /> },
        { path: "imageview/:id", element: <ImagePreview /> },
        {
          path: "edit-public-view/:projectName/:id",
          element: <PublicView isEdit={true} />,
        },

        {
          path: "",
          element: <SuperAdminAccess />,
          children: [
            { path: "add-user", element: <AddUser /> },
            { path: "edit-user/:id", element: <EditUser /> },
            { path: "user-list", element: <UserList /> },
          ],
        },
        { path: "home", element: <Home /> },
        { path: "profile", element: <Profile /> },

        { path: "/project-list", element: <ProjectListing /> },
      ],
    },
  ]);

  return element;
}
